// O tour pertence a UM módulo — sair dele é sair do tour.
//
// O host mora no layout global (`main.vue`) sob a flag da Jornada, então
// sobrevive a qualquer navegação. Sem esta regra, quem estava no passo 3 do Fee
// Fixo e clicava no menu lateral levava o overlay junto: véu de tela cheia
// (`--tour-scrim`, alpha 0,55) sobre o CRM, com um balão dizendo "Clique em
// Importar clientes" (achado em review, 14/08).
//
// Havia um segundo sintoma, mais sutil: fora do módulo o assinante de
// `EVENTO_PROXIMA_ETAPA` já foi desligado (ele vive no shell do Fee Fixo), então
// "Ir para: <próxima etapa>" MARCAVA a etapa como concluída e não encadeava
// nada — sem erro e sem feedback.
import { rotaInicialDoModulo } from './module-routes'

// O `name` da rota inicial é o prefixo de todas as rotas do módulo:
// 'fee-fixo.dashboard' → 'fee-fixo' cobre .clientes, .simulacao, .pipeline...
const prefixoDoModulo = (moduleKey) => {
  const inicial = rotaInicialDoModulo(moduleKey)
  if (!inicial) return null
  return inicial.split('.')[0]
}

/**
 * A rota atual ainda pertence ao módulo do tour?
 *
 * ⚠️ FAIL-OPEN por decisão: sem `moduleKey`, sem nome de rota, ou com módulo
 * fora do mapa de rotas, devolve `true` (não encerra). Encerrar por engano é
 * pior que o sintoma — o usuário perde o progresso do tour por um dado que
 * faltou, e o mapa de `module-routes.js` é dívida declarada que apodrece em
 * silêncio quando um módulo renomeia rota.
 *
 * @param {String} moduleKey slug do módulo dono do tour ('fee-fixo')
 * @param {String} routeName `$route.name` da rota atual
 */
export function rotaPertenceAoModulo(moduleKey, routeName) {
  const prefixo = prefixoDoModulo(moduleKey)
  if (!prefixo || !routeName) return true
  return routeName === prefixo || routeName.startsWith(`${prefixo}.`)
}
